import { render, staticRenderFns } from "./DocumentationWrapper.vue?vue&type=template&id=b019449a&scoped=true&"
import script from "./DocumentationWrapper.vue?vue&type=script&lang=js&"
export * from "./DocumentationWrapper.vue?vue&type=script&lang=js&"
import style0 from "./DocumentationWrapper.vue?vue&type=style&index=0&id=b019449a&lang=scss&scoped=true&"
import style1 from "./DocumentationWrapper.vue?vue&type=style&index=1&id=b019449a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b019449a",
  null
  
)

export default component.exports